<template>
  <div class="shfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <el-button-group>
              <el-button :type="qsType===1?'primary':''" size="small" @click="changeQs(1)">责任部门</el-button>
              <el-button :type="qsType===0?'primary':''" size="small" @click="changeQs(0)">售后原因</el-button>
              <el-button :type="qsType===2?'primary':''" size="small" @click="changeQs(2)">售后回访</el-button>
            </el-button-group>
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="选择月份">
                <el-date-picker
                  v-model="searchForm.qstime"
                  format="yyyy年MM月"
                  value-format="yyyy-MM"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :clearable="false"
                  type="monthrange">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="责任车间">
                <el-select v-model="searchForm.qsfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="qsLoading" icon="el-icon-s-data" type="primary" @click="getQsData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="qsLoading">
                <GraphicsChart id="qsChart" :option="qsOption"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            售后数据明细
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm.shtime"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  type="daterange">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="shLoading" icon="el-icon-s-data" type="primary" @click="getShData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content" v-loading="shLoading">
            <el-row>
              <el-col :span="12" style="padding-right: 20px">
                <table class="tcf-bb-table">
                  <thead>
                    <tr>
                      <th>各车间承担售后费用总计</th>
                      <th v-for="d in shInfo.deptlst">{{d.name}}导致售后（占比）</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{shInfo.totalamount}}</td>
                    <td v-for="d in shInfo.deptlst">{{d.percentage}}%</td>
                  </tr>
                  </tbody>
                </table>
                <table class="tcf-bb-table" style="margin-top: 10px">
                  <thead>
                  <tr>
                    <th>类别</th>
                    <th>重做金额</th>
                    <th>类别</th>
                    <th>重做金额</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="d in shInfo.czjelst">
                    <td>{{d.onename}}</td>
                    <td style="font-weight: bold;color:#f56c6c">{{d.oneamount}}</td>
                    <td>{{d.twoname}}</td>
                    <td style="font-weight: bold;color:#f56c6c">{{d.twoamount}}</td>
                  </tr>
                  </tbody>
                </table>
                <table class="tcf-bb-table" style="margin-top: 10px">
                  <thead>
                  <tr>
                    <th colspan="6">售后占比分析</th>
                  </tr>
                  <tr>
                    <th>序号</th>
                    <th>车间</th>
                    <th>重做金额</th>
                    <th>正单金额</th>
                    <th>售后不良率</th>
                    <th>各车间比重</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="d in shInfo.shzblst">
                    <td>{{d.xh}}</td>
                    <td>{{d.name}}</td>
                    <td>{{d.czamount}}</td>
                    <td>{{d.orderamount}}</td>
                    <td>{{d.bll!=null?`${d.bll}%`:''}}</td>
                    <td>{{d.gcjbz}}%</td>
                  </tr>
                  </tbody>
                </table>
              </el-col>
              <el-col :span="12">
                <GraphicsChart id="sh" :option="shOptions" :height="463"/>
                <div style="width: 100%;height: 10px"></div>
                <GraphicsChart id="circle" :option="shcircleOption" :height="477"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            售后分析表
            <el-form :inline="true" size="small" :model="searchForm" style="float: right;">
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm.fxtime"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  type="daterange">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="车间">
                <el-select v-model="searchForm.fxfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
              <el-form-item label="责任部门">
                <el-select v-model="searchForm.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                  <el-option v-for="d in afterReasonOption" :label="d.label" :value="d.value">{{d.label}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="fxLoading" icon="el-icon-s-data" type="primary" @click="getFxData">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content" v-loading="fxLoading">
            <table class="tcf-bb-table">
              <thead>
                <tr>
                  <th rowspan="2" style="width: 80px">类别</th>
                  <th v-for="d in fxdeptlst" :colspan="d.colspan" >{{d.name}}</th>
                  <th></th>
                </tr>
                <tr>
                  <th v-for="d in fxbData">{{d.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>客诉次数</th>
                  <td v-for="d in fxbData">{{d.kscs}}</td>
                </tr>
                <tr>
                  <th>次数占比</th>
                  <td v-for="d in fxbData">{{d.cszb}}%</td>
                </tr>
                <tr>
                  <th>板件数量</th>
                  <td v-for="d in fxbData">{{d.bjsl}}</td>
                </tr>
                <tr>
                  <th>数量占比</th>
                  <td v-for="d in fxbData">{{d.slzb}}%</td>
                </tr>
                <tr>
                  <th>客诉金额</th>
                  <td v-for="d in fxbData">{{d.ksje}}</td>
                </tr>
                <tr>
                  <th>金额占比</th>
                  <td v-for="d in fxbData">{{d.jezb}}%</td>
                </tr>
              </tbody>
            </table>
            <GraphicsChart id="fx" :option="fxOptions" style="margin-top: 20px"/>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import GraphicsChart from '../../../components/Charts/GraphicsChart'
import { getAfterReasonReport, getAfterDeptReport, getAfterVisitReport, getAfterDetailStatisticsData, getAfterAnalysisTableData } from '@/api/tj'
import { getFactoryList, getAfterReason, getGroupInfoByUser } from '@/api/erp'
import { dateFormat } from '@/utils/index'

export default {
  name: 'shfx',
  components: {
    GraphicsChart
  },
  data() {
    return {
      factoryList: [],
      afterReasonOption: [],
      qsType: 1,
      searchForm: {
        qstime: [],
        qsfactory: '',
        shtime: [],
        fxtime: [],
        fxfactory: '',
        depts: []
      },
      qsOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      shOptions: {
        title: false,
        credits: {
          enabled: false
        }
      },
      shcircleOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      qsLoading: false,
      shLoading: false,
      shInfo: {
        totalamount: 0,
        deptlst: [],
        czjelst: [],
        shzblst: []
      },
      fxLoading: false,
      fxbData: [],
      fxdeptlst: [],
      fxOptions: {
        title: false,
        credits: {
          enabled: false
        }
      },
      group: {
        dBrand: 1
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    getAfterReason().then(response => {
      let afterReasonOption = []
      for (let r of response.data) {
        let children = []
        for (let a of r.list) {
          children.push({ value: a.rid, label: a.name })
        }
        afterReasonOption.push({ value: r.arid, label: r.name, children: children })
      }
      this.afterReasonOption = afterReasonOption
    }).catch(() => {})
    const end = new Date()
    const start = new Date()
    start.setMonth(start.getMonth() - 11)
    const startTime = dateFormat('YYYY-mm', start)
    const endTime = dateFormat('YYYY-mm', end)
    this.searchForm.qstime.push(startTime)
    this.searchForm.qstime.push(endTime)
    const year = end.getFullYear()
    let month = end.getMonth() + 1
    let day = end.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.shtime.push(year + '-' + month + '-01')
    this.searchForm.shtime.push(year + '-' + month + '-' + day)
    this.searchForm.fxtime.push(year + '-' + month + '-01')
    this.searchForm.fxtime.push(year + '-' + month + '-' + day)
    this.getDeptData()
    this.getShData()
    this.getFxData()
  },
  methods: {
    changeQs(n) {
      this.qsType = n
      this.getQsData()
    },
    getQsData() {
      if (this.qsType === 0) {
        this.getReasonData()
      } else if (this.qsType === 1) {
        this.getDeptData()
      } else if (this.qsType === 2) {
        this.getVisitData()
      }
    },
    getReasonData() {
      this.qsLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.qstime !== null && this.searchForm.qstime.length === 2) {
        startTime = this.searchForm.qstime[0]
        endTime = this.searchForm.qstime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        factory: this.searchForm.qsfactory
      }
      getAfterReasonReport(data).then(response => {
        const chart = {
          chart: {
            type: 'spline',
            inverted: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: {
            text: '售后原因趋势分析'
          },
          yAxis: {
            title: {
              text: '客诉次数'
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          xAxis: {
            categories: response.data.dateMonth,
            crosshair: true,
            title: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: response.data.lineData
        }
        this.qsOption = chart
        this.qsLoading = false
      }).catch(() => {
        this.qsLoading = false
      })
    },
    getDeptData() {
      this.qsLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.qstime !== null && this.searchForm.qstime.length === 2) {
        startTime = this.searchForm.qstime[0]
        endTime = this.searchForm.qstime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        factory: this.searchForm.qsfactory
      }
      getAfterDeptReport(data).then(response => {
        const chart = {
          chart: {
            type: 'spline',
            inverted: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: {
            text: '责任部门趋势分析'
          },
          yAxis: {
            title: {
              text: '客诉次数'
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          xAxis: {
            categories: response.data.dateMonth,
            crosshair: true,
            title: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: response.data.lineData
        }
        this.qsOption = chart
        this.qsLoading = false
      }).catch(() => {
        this.qsLoading = false
      })
    },
    getVisitData() {
      this.qsLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.qstime !== null && this.searchForm.qstime.length === 2) {
        startTime = this.searchForm.qstime[0]
        endTime = this.searchForm.qstime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        factory: this.searchForm.qsfactory
      }
      getAfterVisitReport(data).then(response => {
        const chart = {
          chart: {
            type: 'spline',
            inverted: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: {
            text: '售后回访趋势分析'
          },
          yAxis: {
            title: {
              text: '售后评价平均分'
            }
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          xAxis: {
            categories: response.data.dateMonth,
            crosshair: true,
            title: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}分'
              }
            }
          },
          series: response.data.lineData
        }
        this.qsOption = chart
        this.qsLoading = false
      }).catch(() => {
        this.qsLoading = false
      })
    },
    getShData() {
      this.shLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.shtime !== null && this.searchForm.shtime.length === 2) {
        startTime = this.searchForm.shtime[0]
        endTime = this.searchForm.shtime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid
      }
      getAfterDetailStatisticsData(data).then(response => {
        this.shInfo.totalamount = response.data.totalamount
        this.shInfo.deptlst = response.data.deptlst
        this.shInfo.czjelst = response.data.czjelst
        this.shInfo.shzblst = response.data.shzblst
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: {
            text: '各部门重做金额对比图'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> 元<br/>'
          },
          series: [{
            name: '重做金额',
            colorByPoint: true,
            data: response.data.deptCompared
          }]
        }
        this.shOptions = chart
        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: '售后占比图'
          },
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b> 元'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
              }
            }
          },
          series: [{
            name: '重做金额',
            colorByPoint: true,
            data: response.data.afterPercentage
          }]
        }
        this.shcircleOption = circle
        this.shLoading = false
      }).catch(() => {
        this.shLoading = false
      })
    },
    getFxData() {
      this.fxLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.fxtime !== null && this.searchForm.fxtime.length === 2) {
        startTime = this.searchForm.fxtime[0]
        endTime = this.searchForm.fxtime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        factory: this.searchForm.fxfactory,
        depts: this.searchForm.depts.join(','),
        userid: this.user.dUserid
      }
      let cjname = ''
      if (data.factory !== null && data.factory !== '' && data.factory !== undefined) {
        for (const f of this.factoryList) {
          if (data.factory === f.factory_id) {
            cjname = f.simple_name
            break
          }
        }
      }
      getAfterAnalysisTableData(data).then(response => {
        this.fxdeptlst = response.data.fxdeptlst
        this.fxbData = response.data.fxbData
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: {
            text: cjname + '重做金额对比图'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> 元<br/>'
          },
          series: [{
            name: '重做金额',
            colorByPoint: true,
            data: response.data.fxbCompared
          }]
        }
        this.fxOptions = chart
        this.fxLoading = false
      }).catch(() => {
        this.fxLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tcf-bb-table{
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 13px;
  text-align: center;
  thead{
    color: #909399;
    font-weight: 500;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 10px;
      }
    }
  }
  tbody{
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 10px;
      }
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
         background: #f3f6f9;
      }
    }
  }
}
</style>
